import { useLanguage } from "@digipost/translate";
import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Dispatch } from "../infrastructure/redux/actions";
import { logoutAction } from "../infrastructure/redux/app/app-actions";
import { AppState } from "../infrastructure/redux/app/app-reducer";
import { ReduxState } from "../infrastructure/redux/state";
import DigipostHeader from "./DigipostHeader";
import SigneringHeader from "./SigneringHeader";

const Header: FC = () => {
  const dispatch = useDispatch<Dispatch>();
  const logout = (): Promise<void> => dispatch(logoutAction());

  const user = useSelector((state: ReduxState) => state.user.info);
  const authOK = useSelector((state: ReduxState) => state.user.auth !== "NONE");
  const mode = useSelector((state: ReduxState) => state.app.mode);
  const paramMode = useSelector((state: ReduxState) => state.app.params.mode);
  const { language } = useLanguage();

  const forsideChooser = (appMode: AppState["mode"]): string => {
    const languagePath = language === "nb" ? "" : language;
    switch (appMode) {
      case "bedrift":
        return language === "en"
          ? "/en/business"
          : `${language === "nb" ? "" : `/nn`}/bedrift/`;
      case "person":
        return `/${languagePath}`;
      default:
        return `/${languagePath}`;
    }
  };

  const forsiden = forsideChooser(mode);
  return paramMode === "signering" ? (
    <SigneringHeader authOK={authOK} logout={logout} user={user} />
  ) : (
    <DigipostHeader
      authOK={authOK}
      logout={logout}
      user={user}
      forsideLink={forsiden}
    />
  );
};

export default Header;
